module.exports = __webpack_public_path__ + "static/media/share-content.1701836f.svg";